import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

interface EmptyStateProps {
    icon: LucideIcon
    title: string
    description?: ReactNode
    action?: ReactNode
    className?: string
    compact?: boolean
}

const EmptyState = ({ icon: Icon, title, description, action, className, compact = false }: EmptyStateProps): ReactNode => {
    return (
        <div className={cn('flex flex-col items-center justify-center text-center', compact ? 'px-4 py-8' : 'px-6 py-14', className)}>
            <span className='flex size-11 items-center justify-center rounded-full bg-accent text-accent-foreground'>
                <Icon className='size-5' aria-hidden='true' />
            </span>

            <p className='mt-3 text-sm font-semibold text-foreground'>
                {title}
            </p>

            {description && (
                <p className='mt-1 max-w-sm text-sm text-muted-foreground'>
                    {description}
                </p>
            )}

            {action && <div className='mt-4'>{action}</div>}
        </div>
    )
}

export default EmptyState
